import React, { Component } from 'react';
import { Route, NavLink, Switch, Redirect } from 'react-router-dom';

class PrivacyPolicy extends Component {
    state = {
        loadedPost: null
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }
    // b, strong {
    //     font-weight: bolder;
    // }
    render() {
        const hTag = { textAlign: 'center', marginTop: '30px' };
        const parentDiv = {
            marginLeft: '500px', width: '900px',
            fontSize: '1.25em',
            lineHeight: '140%',
            fontWeight: 'bold',
            fontStyle: 'italic'
        };

        const divData = {
            marginLeft: '500px', width: '1000px',
        };
        const heading = {
            fontSize: '1.25em',
            lineHeight: '140%',
            fontWeight: 'bolder'
        };
        const data = {
            textAlign: 'center'
        };

        const h2Heading = {
            fontSize: '1.75em',
            color: '#047A9C',
            fontWeight: '100',
            marginTop: '40px',
            paddingBottom: '10px'
        }

        const h1tag = {
            marginLeft: '500px', width: '1000px',
            fontSize: '3em',
            fontWeight: '100',
            marginBottom: '40px'
        }
        const subH = {
            fontWeight: 'normal',
            color: '#252525',
            fontSize: '1.28571em',
            paddingBottom: '5px'
        }

        return (
            <div>
                <NavLink
                    to="/login/"
                    activeStyle={{
                        color: '#fa923f',
                        textDecoration: 'underline'
                    }}>back</NavLink>
                <div style={h1tag}>
                    <br />
                    Digital Learning Services Privacy Notice
       </div>
                <div style={divData}>
                    <div style={h2Heading}>Introduction</div>
                    <p style={{ paddingBottom: '10px' }}>
                        This Privacy Policy describes how Pearson Education, Inc. (Pearson) collects, protects, uses and shares personal information of Users of the Educational Products and Services (Services) that link to this Privacy Policy. The Services are designed to facilitate and support learning and education in Higher Education and, for certain Services, Secondary Education.
       </p>
                    <p style={{ paddingBottom: '10px' }}>
                        Use of the Services is subject to this Privacy Policy, the End User License Agreement (EULA) for the Services and any applicable written agreement executed by Pearson and an Institution or other Educator.
       </p>
                    <p style={{ paddingBottom: '10px' }}>Some Services may reference or link to another site or service. Use of other sites and services (including other Pearson sites and services) may be subject to different terms and privacy policies.</p>
                    <div style={h2Heading}>Collection and Processing</div>
                    <p>Pearson collects and processes data in order to provide the Services for educational purposes. This data may include Personal Information.</p>
                    <div style={subH}>Payment Data</div>
                    <p style={{ paddingBottom: '10px' }}>If a Customer purchases the Services online directly from Pearson, payment data submitted by that Customer will be used and disclosed to the Customer’s financial institution and Pearson’s payment processing vendor for the purpose of processing payment for the Services ordered.</p>
                    <div style={subH}>Account Data</div>
                    <p style={{ paddingBottom: '10px' }}>Pearson collects and processes Account Data to set up, maintain and enable a User account to use the Services. Account Data includes a User’s name (unless an alias is used with Educator or Institution approval/coordination), email address, user name and password, as well as the Institution and course identifier for any courses for which User uses the Services. With coordination/approval by the Educator, a User may be registered for a User account using an alias* instead of actual first and last name. Account Data does not include student coursework or responses, scores, grades or instructor feedback on interactive exercises, assignments or assessments.</p>
                    <div style={subH}>Course Data</div>
                    <p style={{ paddingBottom: '10px' }}>
                        Course Data means educational data collected, generated or processed through use of the Services in connection with educational coursework. Course Data includes assignments, student coursework, responses to interactive exercises, assignments and assignments, scores, grades and instructor comments. Pearson collects and processes Course Data in order to provide the Services to Users, Educators and Institutions for educational purposes.
     </p>
                    <div style={subH}>Google Drive</div>
                    <p style={{ paddingBottom: '10px' }}>
                        Some Services may have the capability to connect to your Google Drive so that you can upload or download documents directly from or into your Google Drive. Before they do so, you will receive a prompt asking you to click "Allow" to enable the Services to connect to your Google Drive. You may remove this connection in the My Account settings for your Google account at any time. Pearson will use this connection to access your Google Drive only for the purpose of uploading or downloading documents that you specifically select with limited metadata to allow identification and retrieval, so that you can access and use the documents within the Services or download them to Google Drive. Pearson will use, process and store these documents and associated personal data in accordance with this Privacy Notice.
     </p>
                    <div style={subH}>Cookies and Related Technologies</div>
                    <p style={{ paddingBottom: '10px' }}>
                        The Services use cookies to enable Users to sign-in to the Services and access stored preferences and settings. Users, Educators and Institutions have a variety of tools to control the use of cookies, web beacons and similar technologies, including browser controls to block and delete cookies. Disabling or blocking these technologies, however, may prevent or impair required functionality and use of the Services.
     </p>
                </div>
            </div>
        )
    }
}

export default PrivacyPolicy;


// WEBPACK FOOTER //
// ./src/components/footer/privacyPolicy.js